import { render, staticRenderFns } from "./TbFilaDetail.vue?vue&type=template&id=c5474960&scoped=true"
import script from "./TbFilaDetail.vue?vue&type=script&lang=js"
export * from "./TbFilaDetail.vue?vue&type=script&lang=js"
import style0 from "./TbFilaDetail.vue?vue&type=style&index=0&id=c5474960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5474960",
  null
  
)

export default component.exports